/* ============================================================
   AURAPEAKS CE — theme.js
   AJAX cart drawer + nav + reveals. No dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/<[^>]*>/g, '');
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerBody = document.querySelector('[data-cart-body]');
  var drawerFoot = document.querySelector('[data-cart-foot]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  var lastFocused = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function focusables() {
    if (!drawer) return [];
    return Array.prototype.slice.call(drawer.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    document.body.classList.add('cart-open');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    var f = focusables();
    var target = drawer.querySelector('.cart-drawer__close') || f[0];
    if (target) setTimeout(function () { target.focus(); }, 60);
  }

  function closeDrawer() {
    document.body.classList.remove('cart-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  /* Trap Tab inside the drawer while it is open */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    if (!document.body.classList.contains('cart-open')) return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function refreshCart() {
    return fetch(window.theme.cartUrl + '.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function updateShipBar(cart) {
    var bar = document.querySelector('[data-ship-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    if (threshold <= 0) { bar.style.display = 'none'; return; }
    var total = cart.total_price || 0;
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var fill = bar.querySelector('[data-ship-fill]');
    var text = bar.querySelector('[data-ship-text]');
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (total >= threshold) {
        text.innerHTML = '\u26A1 <strong>You have unlocked free shipping.</strong>';
        bar.classList.add('is-complete');
      } else {
        text.innerHTML = 'You are <strong>' + formatMoney(threshold - total) + '</strong> away from free shipping.';
        bar.classList.remove('is-complete');
      }
    }
  }

  function renderCart(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    updateShipBar(cart);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    if (!drawerBody) return cart;

    if (cart.item_count === 0) {
      drawerBody.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p><strong>Your cart is empty.</strong></p>' +
        '<p>Charge it up.</p>' +
        '<a class="btn btn--volt" href="' + ((window.theme && window.theme.allProductsUrl) || '/collections/all') + '" data-cart-close>Shop CE \u26A1</a>' +
        '</div>';
      if (drawerFoot) drawerFoot.style.display = 'none';
      return cart;
    }

    if (drawerFoot) drawerFoot.style.display = '';
    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image
        ? item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_180x$1$2')
        : '';
      html +=
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          (img ? '<img class="cart-line__img" src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '<div class="cart-line__img"></div>') +
          '<div>' +
            '<p class="cart-line__title">' + escapeHtml(item.product_title) + '</p>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<div class="cart-line__qty" aria-label="Quantity">' +
              '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">\u2212</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-qty-remove>Remove</button>' +
          '</div>' +
          '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    });
    drawerBody.innerHTML = html;
    return cart;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  /* Quantity change / remove inside drawer */
  document.addEventListener('click', function (e) {
    var changeBtn = e.target.closest('[data-qty-change]');
    var removeBtn = e.target.closest('[data-qty-remove]');
    if (!changeBtn && !removeBtn) return;

    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qty = 0;

    if (changeBtn) {
      var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10) || 0;
      qty = Math.max(0, current + parseInt(changeBtn.getAttribute('data-qty-change'), 10));
    }

    fetch(window.theme.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var originalText = button ? button.innerHTML : '';
    if (button) { button.innerHTML = 'Adding\u2026'; button.disabled = true; }

    fetch(window.theme.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      })
      .then(function (item) {
        try {
          document.dispatchEvent(new CustomEvent('aurapeaks:added', {
            detail: {
              variant_id: item && item.variant_id,
              product_id: item && item.product_id,
              title: item && item.product_title,
              quantity: item && item.quantity,
              value: item && item.final_line_price ? item.final_line_price / 100 : 0,
              currency: (window.theme && window.theme.currency) || ''
            }
          }));
        } catch (err) { /* analytics must never break add to cart */ }
        return refreshCart();
      })
      .then(function () {
        if (button) { button.innerHTML = 'Added \u26A1'; }
        openDrawer();
        setTimeout(function () {
          if (button) { button.innerHTML = originalText; button.disabled = false; }
        }, 1200);
      })
      .catch(function () {
        if (button) { button.innerHTML = 'Sold out / unavailable'; button.disabled = false; }
        setTimeout(function () { if (button) button.innerHTML = originalText; }, 2000);
      });
  });

  /* ---------- Generic quantity steppers (buy box / product page) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap && wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = val;
  });

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Scroll reveals ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }


  /* ---------- Plan selector: 1 pouch / 2 pouches / Subscribe & Save ---------- */
  (function () {
    var plan = document.querySelector('[data-plan]');
    var form = document.querySelector('[data-buy-form]');
    if (!plan || !form) return;

    var qtyInput = form.querySelector('[data-qty-input]');
    var planInput = form.querySelector('[data-selling-plan-input]');
    var qtyWrap = form.querySelector('.qty');

    function apply() {
      var checked = plan.querySelector('input[name="purchase_type"]:checked');
      if (!checked) return;

      var qty = parseInt(checked.getAttribute('data-plan-qty'), 10) || 1;
      var isSub = checked.getAttribute('data-plan-type') === 'subscription';

      if (planInput) planInput.value = checked.getAttribute('data-selling-plan') || '';
      if (qtyInput) { qtyInput.value = qty; qtyInput.min = qty; }

      /* quantity is fixed by the chosen plan — the stepper would break the pricing */
      if (qtyWrap) qtyWrap.classList.toggle('is-locked', qty > 1 || isSub);

      plan.querySelectorAll('[data-plan-opt]').forEach(function (opt) {
        var i = opt.querySelector('input');
        opt.classList.toggle('is-selected', !!(i && i.checked));
      });
    }

    plan.addEventListener('change', function (e) {
      if (e.target.name === 'purchase_type') apply();
    });
    apply();
  })();

  /* ---------- Sticky ATC: mirror selected variant + quantity ---------- */
  (function () {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) return;
    var stickyId = sticky.querySelector('[data-sticky-id]');
    var stickyQty = sticky.querySelector('[data-sticky-qty]');
    var stickyPrice = sticky.querySelector('[data-sticky-price]');
    var select = document.querySelector('[data-variant-select]');
    var qtyInput = document.querySelector('.buybox__row [data-qty-input]') ||
                   document.querySelector('[data-qty-input]');

    function syncVariant() {
      if (!select || !stickyId) return;
      stickyId.value = select.value;
      var opt = select.options[select.selectedIndex];
      if (stickyPrice && opt) {
        var m = opt.textContent.match(/[\d.,]+\s*$|[^\s]+\s*$/);
        var parts = opt.textContent.split('\u2014');
        if (parts.length > 1) stickyPrice.textContent = parts[parts.length - 1].trim();
      }
    }
    function syncQty() {
      if (!qtyInput || !stickyQty) return;
      stickyQty.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    }

    if (select) select.addEventListener('change', syncVariant);
    if (qtyInput) {
      qtyInput.addEventListener('change', syncQty);
      qtyInput.addEventListener('input', syncQty);
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-qty-step]')) setTimeout(syncQty, 0);
      });
    }
    syncVariant(); syncQty();

    /* Reveal only once the main buy button has scrolled out of view */
    var mainBtn = document.querySelector('.buybox__row [type="submit"]');
    if ('IntersectionObserver' in window && mainBtn) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('is-visible', !en.isIntersecting);
        });
      }, { rootMargin: '0px 0px -80px 0px' });
      so.observe(mainBtn);
    } else {
      sticky.classList.add('is-visible');
    }
  })();

  /* ---------- Announcement bar: rotate + dismiss ---------- */
  (function () {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;

    try {
      if (sessionStorage.getItem('ap_announcement_closed') === '1') {
        bar.style.display = 'none';
        return;
      }
    } catch (err) {}

    var msgs = bar.querySelectorAll('[data-announcement-msg]');
    var speed = parseInt(bar.getAttribute('data-announcement-rotate'), 10) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (msgs.length > 1 && speed > 0 && !reduce) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, speed);
    }

    var close = bar.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.style.display = 'none';
        try { sessionStorage.setItem('ap_announcement_closed', '1'); } catch (err) {}
      });
    }
  })();

  /* ---------- FAQ: one open at a time ---------- */
  (function () {
    var items = document.querySelectorAll('.faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  })();


  /* ---------- PDP gallery: thumbnail → slide ---------- */
  (function () {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var idx = thumb.getAttribute('data-gallery-thumb');

      gallery.querySelectorAll('[data-gallery-slide]').forEach(function (sl) {
        sl.classList.toggle('is-active', sl.getAttribute('data-gallery-slide') === idx);
      });
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  })();

  /* ---------- Quick view: instant product view, no page load ---------- */
  (function () {
    var modal = document.querySelector('[data-qv-modal]');
    if (!modal) return;

    var lastQvFocus = null;
    var QV_FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea';

    function qvFocusables() {
      return Array.prototype.slice.call(modal.querySelectorAll(QV_FOCUSABLE))
        .filter(function (el) { return el.offsetParent !== null; });
    }

    function openQv(data) {
      lastQvFocus = document.activeElement;

      var img = modal.querySelector('[data-qv-img]');
      var name = modal.querySelector('[data-qv-name]');
      var price = modal.querySelector('[data-qv-price-out]');
      var desc = modal.querySelector('[data-qv-desc-out]');
      var idInput = modal.querySelector('[data-qv-id-input]');
      var link = modal.querySelector('[data-qv-link]');
      var qty = modal.querySelector('[data-qty-input]');

      if (img) { img.src = data.image || ''; img.alt = data.title || ''; }
      if (name) name.textContent = data.title || '';
      if (price) price.textContent = data.price || '';
      if (desc) desc.textContent = data.desc || '';
      if (idInput) idInput.value = data.id || '';
      if (link) link.href = data.url || '#';
      if (qty) qty.value = 1;

      document.body.classList.add('qv-open');
      modal.setAttribute('aria-hidden', 'false');
      var close = modal.querySelector('.qv__close');
      if (close) setTimeout(function () { close.focus(); }, 60);
    }

    function closeQv() {
      document.body.classList.remove('qv-open');
      modal.setAttribute('aria-hidden', 'true');
      if (lastQvFocus && typeof lastQvFocus.focus === 'function') {
        lastQvFocus.focus();
        lastQvFocus = null;
      }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quickview]');
      if (trigger) {
        e.preventDefault();
        openQv({
          id: trigger.getAttribute('data-qv-id'),
          title: trigger.getAttribute('data-qv-title'),
          price: trigger.getAttribute('data-qv-price'),
          url: trigger.getAttribute('data-qv-url'),
          image: trigger.getAttribute('data-qv-image'),
          desc: trigger.getAttribute('data-qv-desc')
        });
        return;
      }
      if (e.target.closest('[data-qv-close]')) closeQv();
    });

    document.addEventListener('keydown', function (e) {
      if (!document.body.classList.contains('qv-open')) return;
      if (e.key === 'Escape') { closeQv(); return; }
      if (e.key !== 'Tab') return;
      var f = qvFocusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Close quick view once the item lands in the cart drawer */
    document.addEventListener('submit', function (e) {
      if (e.target.closest('.qv__form')) {
        setTimeout(closeQv, 420);
      }
    });
  })();


  /* ---------- Built-for carousel: auto-advancing tabs ---------- */
  (function () {
    var root = document.querySelector('[data-builtfor]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-builtfor-tab]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-builtfor-slide]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.builtfor__item'));
    if (tabs.length < 2) return;

    var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    var autoplay = root.getAttribute('data-autoplay') !== 'off';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    function show(i, focusTab) {
      current = (i + tabs.length) % tabs.length;
      tabs.forEach(function (t, n) {
        var on = n === current;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      items.forEach(function (li, n) { li.classList.toggle('is-active', n === current); });
      slides.forEach(function (sl, n) {
        var on = n === current;
        sl.classList.toggle('is-active', on);
        if (on) { sl.removeAttribute('aria-hidden'); } else { sl.setAttribute('aria-hidden', 'true'); }
      });
      if (focusTab && tabs[current]) tabs[current].focus();
      restartProgress();
    }

    function restartProgress() {
      items.forEach(function (li, n) {
        var fill = li.querySelector('.builtfor__progress-fill');
        if (!fill) return;
        fill.style.transition = 'none';
        fill.style.width = '0%';
        if (n === current && timer && !reduce) {
          /* force reflow so the transition restarts */
          void fill.offsetWidth;
          fill.style.transition = 'width ' + interval + 'ms linear';
          fill.style.width = '100%';
        }
      });
    }

    function start() {
      if (!autoplay || reduce || timer) return;
      timer = setInterval(function () { show(current + 1); }, interval);
      restartProgress();
    }
    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
      restartProgress();
    }

    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { stop(); show(n); });
      t.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); stop(); show(n + 1, true); }
        else if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); stop(); show(n - 1, true); }
        else if (k === 'Home') { e.preventDefault(); stop(); show(0, true); }
        else if (k === 'End') { e.preventDefault(); stop(); show(tabs.length - 1, true); }
      });
    });

    /* mouseover/mouseout bubble and are dispatched more reliably than
       mouseenter/mouseleave; relatedTarget tells us if we truly left the section. */
    root.addEventListener('mouseover', stop);
    root.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) start();
    });
    root.addEventListener('pointerdown', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) start();
    });

    /* Only run while the section is actually on screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(root);
    } else {
      start();
    }
  })();

  /* ---------- Initial cart count ---------- */
  refreshCart();
})();
